import { render } from "./Profiles.vue?vue&type=template&id=464b6444&scoped=true"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"

import "./Profiles.vue?vue&type=style&index=0&id=464b6444&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464b6444"]])

export default __exports__